import React from 'react'
import { IBservicechangeStepsContextProvider } from '../../context/IBservicechangeContext'
import { IBservicechangeStepRoutes } from '../../routes/IBservicechange/IBservicechange'

export default function ContactInfoChangeWithStepsContext() {
  return (
    <IBservicechangeStepsContextProvider>
      <IBservicechangeStepRoutes />
    </IBservicechangeStepsContextProvider>
  )
}
